<template>
  <div data-v-24230dbb="" data-v-e5781868="" class="liveEntertainment mainContent top50">
    <div data-v-24230dbb="" class="content">
            <div data-v-24230dbb="" class="bannerList" >
        <div data-v-24230dbb="" :class="`item box${index<2 ? index+1 : 3}`" v-for="(item, index) in gameList" :key="index"  v-if="item.app_state == 1">
          <img data-v-24230dbb="" :src="imgList[index]" />
          <div data-v-24230dbb="" class="title">
            <h1 data-v-24230dbb="">{{item.name}}</h1>
            <p data-v-24230dbb="" v-if="item.app_state == 1">主流电竞</p>
            <p data-v-24230dbb="" v-else>平台维护中</p>
          </div>
          <div data-v-24230dbb="" class="coins" v-if="item.app_state == 1"><img data-v-24230dbb="" src="/static/image/amount.39372dec.svg" /><span data-v-24230dbb="">{{2238 + index*120}}人</span></div>
          <div data-v-24230dbb="" class="gameList" v-if="item.app_state == 1">
            <a data-v-24230dbb="" @click="$parent.openGamePage(item.platform_name, item.game_code, '')" class="btnYellow buttonSolid"
              >立即游戏
              <svg data-v-338e1447="" data-v-24230dbb="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
            ></a>
          </div>
        </div>
        
              <div data-v-24230dbb="" class="item box3">
          <img data-v-24230dbb="" src="/static/image/jingqingqidai.png" />
          <div data-v-24230dbb="" class="title">
            <h1 data-v-24230dbb="">敬请期待</h1>
            <p data-v-24230dbb=""></p>
          </div>
        
        </div>
      </div>
      <div data-v-24230dbb="" class="bannerList" v-if="false">
        <div data-v-24230dbb="" class="item box1">
          <img data-v-24230dbb="" src="/static/image/banner1.png_.ecc6963f.webp" />
          <div data-v-24230dbb="" class="title">
            <h1 data-v-24230dbb="">主流电竞</h1>
            <p data-v-24230dbb="">单注最高200万 豪客首选</p>
          </div>
          <div data-v-24230dbb="" class="coins"><img data-v-24230dbb="" src="/static/image/amount.39372dec.svg" /><span data-v-24230dbb="">2078人</span></div>
         
        </div>
        <div data-v-24230dbb="" class="item box2">
          <img data-v-24230dbb="" src="/static/image/banner2.png_.53a21e25.webp" />
          <div data-v-24230dbb="" class="title">
            <h1 data-v-24230dbb="">雷火电竞</h1>
            <p data-v-24230dbb="">雷火电竞,彻夜嗨</p>
          </div>
          <div data-v-24230dbb="" class="gameList">
            <a data-v-24230dbb="" @click="$parent.openGamePage('ld', '2', '')" class="btnYellow buttonSolid"
              >立即游戏
              <svg data-v-338e1447="" data-v-24230dbb="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
            ></a>
            <div data-v-24230dbb="" class="btnList">
              <span data-v-24230dbb="">百家乐</span><span data-v-24230dbb="">竞咪百家乐</span><span data-v-24230dbb="">轮盘</span><span data-v-24230dbb="">骰宝</span><span data-v-24230dbb="">龙虎</span><span data-v-24230dbb="">牛牛 </span><span data-v-24230dbb="">三公</span
              ><span data-v-24230dbb="">21点 </span>
            </div>
          </div>
        </div>
        <div data-v-24230dbb="" class="item box3">
          <img data-v-24230dbb="" src="/static/image/banner3.png_.322d7a7e.webp" />
          <div data-v-24230dbb="" class="title">
            <h1 data-v-24230dbb="">泛亚电竞</h1>
            <p data-v-24230dbb="">品牌老店 特殊玩法</p>
          </div>
          <div data-v-24230dbb="" class="gameList">
            <a data-v-24230dbb=""  @click="$parent.openGamePage('avia', '2', '')" class="btnYellow buttonSolid"
              >立即游戏
              <svg data-v-338e1447="" data-v-24230dbb="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
            ></a>
            <div data-v-24230dbb="" class="btnList">
              <span data-v-24230dbb="">百家乐</span><span data-v-24230dbb="">牛牛</span><span data-v-24230dbb="">温州牌九</span><span data-v-24230dbb="">龙虎</span><span data-v-24230dbb="">三公</span><span data-v-24230dbb="">色碟</span><span data-v-24230dbb="">21点</span>
            </div>
          </div>
        </div>
        <div data-v-24230dbb="" class="item box3">
          <img data-v-24230dbb="" src="/static/image/banner4.png_.35419067.webp" />
          <div data-v-24230dbb="" class="title">
            <h1 data-v-24230dbb="">OB电竞</h1>
            <p data-v-24230dbb="">荷官互动 360度旋转咪牌</p>
          </div>
          <div data-v-24230dbb="" class="gameList">
            <a data-v-24230dbb="" @click="$parent.openGamePage('obgdj', '2', '')" class="btnYellow buttonSolid"
              >立即游戏1
              <svg data-v-338e1447="" data-v-24230dbb="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
            ></a>
            <div data-v-24230dbb="" class="btnList"><span data-v-24230dbb="">骰宝</span><span data-v-24230dbb="">轮盘</span><span data-v-24230dbb="">百家乐 </span><span data-v-24230dbb="">牛牛 </span></div>
          </div>
        </div>
        <div data-v-24230dbb="" class="item box3">
          <img data-v-24230dbb="" src="/static/image/banner5.png_.3be17024.webp" />
          <div data-v-24230dbb="" class="title">
            <h1 data-v-24230dbb="">小艾电竞</h1>
            <p data-v-24230dbb="">
              特有的PLAYBOY真人系统，<br data-v-24230dbb="" />
              深受欧美玩家喜欢
            </p>
          </div>
          <div data-v-24230dbb="" class="gameList">
            <a data-v-24230dbb="" @click="$parent.openGamePage('ia', '2', '')" class="btnYellow buttonSolid"
              >立即游戏
              <svg data-v-338e1447="" data-v-24230dbb="" aria-hidden="true" class="svg-icon iconArrow">
                <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
            ></a>
            <div data-v-24230dbb="" class="btnList"><span data-v-24230dbb="">骰宝</span><span data-v-24230dbb="">轮盘</span><span data-v-24230dbb="">百家乐 </span><span data-v-24230dbb="">牛牛 </span></div>
          </div>
        </div>
      </div>
      <div data-v-24230dbb="" class="list" style="display:none">
        <div data-v-24230dbb="" class="t">
          <svg data-v-338e1447="" data-v-24230dbb="" aria-hidden="true" class="svg-icon iconThumb">
            <use data-v-338e1447="" xlink:href="#icon-iconThumb"></use>
          </svg>
          热门游戏
        </div>
        <div data-v-24230dbb="" class="t">
          <svg data-v-338e1447="" data-v-24230dbb="" aria-hidden="true" class="svg-icon iconThumb">
            <use data-v-338e1447="" xlink:href="#icon-iconThumb"></use>
          </svg>
          推荐活动
        </div>
      </div>
      <div data-v-24230dbb="" class="c" style="display:none">
        <div data-v-05f5db65="" data-v-24230dbb="" class="recommendList">
          <div data-v-05f5db65="" class="topH"></div>
          <div data-v-05f5db65="" class="boxList">
            <div data-v-05f5db65="">
              <div data-v-8dd8d106="" data-v-05f5db65="" class="item">
                <div data-v-8dd8d106="" class="c1">
                  <span data-v-8dd8d106="">D51桌</span
                  ><span data-v-8dd8d106=""
                    ><svg data-v-338e1447="" data-v-8dd8d106="" aria-hidden="true" class="svg-icon clock">
                      <use data-v-338e1447="" xlink:href="#icon-clock"></use></svg
                    ><span data-v-8dd8d106="" id="countdownD051" style="font-size: 16px; color: rgb(119, 119, 128)">00:13</span></span
                  >
                </div>
                <div data-v-8dd8d106="" class="c2">
                  <div data-v-8dd8d106="" class="canvas-container">
                    <div data-v-8dd8d106="" id="lz_loadD051" class="shuffle-wrapper" style="display: none"><span data-v-8dd8d106="" class="shuffle-text">洗牌中</span></div>
                    <div data-v-8dd8d106="" id="lz_load2D051" class="loading-wrapper" style="display: none"><span data-v-8dd8d106="" class="loading-text">loading...</span></div>
                    <div data-v-8dd8d106="" id="luzu_divD051" class="canvas-wrapper" style="display: block">
                      <canvas data-v-8dd8d106="" id="cvsD051" width="368px" height="138px" class="canvas-img"></canvas>
                    </div>
                  </div>
                </div>
                <div data-v-8dd8d106="" class="c3">
                  <div data-v-8dd8d106="" class="txtList">
                    <span data-v-8dd8d106="">庄<a data-v-8dd8d106="" id="l_zhuangD051">0</a></span
                    ><span data-v-8dd8d106="">和<a data-v-8dd8d106="" id="l_heD051">0</a></span
                    ><span data-v-8dd8d106="">闲<a data-v-8dd8d106="" id="l_xianD051">0</a></span>
                  </div>
                  <a data-v-8dd8d106="" class="btn buttonBordered"
                    >快速入桌
                    <svg data-v-338e1447="" data-v-8dd8d106="" aria-hidden="true" class="svg-icon iconArrow">
                      <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                  ></a>
                </div>
              </div>
            </div>
            <div data-v-05f5db65="">
              <div data-v-8dd8d106="" data-v-05f5db65="" class="item">
                <div data-v-8dd8d106="" class="c1">
                  <span data-v-8dd8d106="">D52桌</span
                  ><span data-v-8dd8d106=""
                    ><svg data-v-338e1447="" data-v-8dd8d106="" aria-hidden="true" class="svg-icon clock">
                      <use data-v-338e1447="" xlink:href="#icon-clock"></use></svg
                    ><span data-v-8dd8d106="" id="countdownD052" style="font-size: 16px; color: rgb(119, 119, 128)">00:00</span></span
                  >
                </div>
                <div data-v-8dd8d106="" class="c2">
                  <div data-v-8dd8d106="" class="canvas-container">
                    <div data-v-8dd8d106="" id="lz_loadD052" class="shuffle-wrapper" style="display: none"><span data-v-8dd8d106="" class="shuffle-text">洗牌中</span></div>
                    <div data-v-8dd8d106="" id="lz_load2D052" class="loading-wrapper" style="display: none"><span data-v-8dd8d106="" class="loading-text">loading...</span></div>
                    <div data-v-8dd8d106="" id="luzu_divD052" class="canvas-wrapper" style="display: block">
                      <canvas data-v-8dd8d106="" id="cvsD052" width="368px" height="138px" class="canvas-img"></canvas>
                    </div>
                  </div>
                </div>
                <div data-v-8dd8d106="" class="c3">
                  <div data-v-8dd8d106="" class="txtList">
                    <span data-v-8dd8d106="">庄<a data-v-8dd8d106="" id="l_zhuangD052">0</a></span
                    ><span data-v-8dd8d106="">和<a data-v-8dd8d106="" id="l_heD052">0</a></span
                    ><span data-v-8dd8d106="">闲<a data-v-8dd8d106="" id="l_xianD052">1</a></span>
                  </div>
                  <a data-v-8dd8d106="" class="btn buttonBordered"
                    >快速入桌
                    <svg data-v-338e1447="" data-v-8dd8d106="" aria-hidden="true" class="svg-icon iconArrow">
                      <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div data-v-66b11e6c="" data-v-24230dbb="" class="baccarat2021 liveEntertainment">
          <div data-v-66b11e6c="" class="timeDiv">
            <svg data-v-338e1447="" data-v-66b11e6c="" aria-hidden="true" class="svg-icon baccarat-crown">
              <use data-v-338e1447="" xlink:href="#icon-baccarat-crown"></use>
            </svg>
            {{$store.state.appInfo.title}}百家乐大赛 <span data-v-66b11e6c="" class="sub-title">邀您一起参赛</span>
          </div>
          <ul data-v-66b11e6c="" class="c">
            <li data-v-66b11e6c="">
              <p data-v-66b11e6c="">积分</p>
              <p data-v-66b11e6c="">0</p>
            </li>
            <li data-v-66b11e6c="">
              <p data-v-66b11e6c="">奖金</p>
              <p data-v-66b11e6c="">0</p>
            </li>
            <li data-v-66b11e6c="">
              <p data-v-66b11e6c="">排名</p>
              <p data-v-66b11e6c="">200+</p>
            </li>
          </ul>
          <div data-v-66b11e6c="" class="countDowmTime">倒计时：05天 00时 27分</div>
          <div data-v-66b11e6c="" class="button">了解详情</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'eSports',
  data() {
    return {
         gameList: [],
      imgList:[
        '/static/image/gaming/egame.webp'
        ,'/static/image/gaming/obdj.webp'
        ,'/static/image/gaming/aviadj.webp'
      ,'/static/image/gaming/iadj.webp'
      ,'/static/image/gaming/tfdj.webp'

      ]
    };
  },
  created() {
    let that = this;
    that.getGameList();

  },
  methods: {
        getGameList() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun.get('/api/game/list', { category: 'gaming' }).then(res => {
        if (res.code == 200) {
          that.gameList = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
  },
  mounted() {
    let that = this;
    var mySwiper = new Swiper('.bannerSwiper .swiper', {
      slidesPerView: 'auto',
      pagination: {
        el: '.bannerSwiper .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.bannerSwiper .swiper-button-next',
        prevEl: '.bannerSwiper .swiper-button-prev',
      },
    });
    var swiperList = new Swiper('.box .swiper-img', {
      navigation: {
        nextEl: '.swiper-img .swiper-button-next',
        prevEl: '.swiper-img .swiper-button-prev',
      },
    });
    var swiper = new Swiper('.k8BrandWay .c .timeline .swiper', {
      navigation: {
        nextEl: '.k8BrandWay .c .timeline .tool.next',
        prevEl: '.k8BrandWay .c .timeline .tool.prev',
      },
    });
    $('.k8BrandWay .c .timeline .swiper .swiper-slide .swiper-content .items .item').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
      var u = $(this).index();
      var b = ((u + 1) / 7) * 100;
      console.log(b);
      $(this)
        .parents('.swiper-slide')
        .find('.swiper-content .line .activeState')
        .css('width', b + '%');
      var i = $(this).parents('.swiper-slide').index();
      if (i > 1) {
        for (var t = 0; t < i; t++) {
          if (t > 1) {
            $('.k8BrandWay .c .timeline .swiper .swiper-slide').eq(t).find('.swiper-content .line .activeState').css('width', '100%');
          }
        }
      }
      var m = i * 7;
      var o = m + u;
      // console.log(u, i, o);
      swiperList.slideTo(o, 1000, false);
    });
    $('.table table tr').click(function () {
      $('.table table tr').removeClass('active');
      $(this).addClass('active');
      var username = $(this).find('td').eq(1).text();
      var amount = $(this).find('td').eq(2).text();
      $('.profit .user-name').text('会员' + username);
      $('.profit .amount h1').text(amount.replace('元', ''));
    });
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/chunk-40ec6794.0b8a6f7d.css';
.liveEntertainment .bannerList[data-v-24230dbb][data-v-fcebbdc2] {
  height: 7.86rem;
}
.liveEntertainment .bannerList{
  padding-bottom: 30px;
}

</style>



// WEBPACK FOOTER //
// src/components/mode/eSports.vue